import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchUserProfileDone = (_, { payload }) => {
    return payload
}

const setSettingsFormDone = (settings, { payload }) => {
  return {
    ...settings,
    ...payload
  }
    
};

const updateSettingsDone = ( settings,{ payload}) =>{
  return {
    ...settings,
    ...payload
  }
}



const initialState = {};

export default createReducer(initialState, {
  [TYPES.USER_PROFILE_DETAILS_FETCHED]: fetchUserProfileDone,
  [TYPES.SET_SETTINGS_FORM_DATA]:setSettingsFormDone,
  [TYPES.UPDATE_COMPANY_DETAILS_DONE]:updateSettingsDone,
  [TYPES.UPDATE_NOTIFICATION_DETAILS_DONE]:updateSettingsDone
});